/**
 * Translations for the habits feature area.
 * Populated by Phase 2 subagents — keep zh and en in lock-step.
 */
const habits = {
  zh: {
    'habits.title': '习惯养成',
    'habits.subtitle': '完成小任务，赚金币又养好习惯',
    'habits.earnTitle': '赚金币的方式',
    'habits.earnHint': '完成小任务 / 答题 / 帮家人做事，都能赚金币',

    'habits.wishlist.kicker': '我的愿望',
    'habits.wishlist.title': '愿望清单',
    'habits.wishlist.count': '{n} 个进行中',
    'habits.wishlist.empty': '爸爸妈妈还没有设置愿望清单',
    'habits.wishlist.status.active': '进行中',
    'habits.wishlist.status.ready': '达标啦',
    'habits.wishlist.status.fulfilled': '已实现',
    'habits.wishlist.status.cancelled': '已取消',

    'habits.reward.kicker': '孩子主动申请',
    'habits.reward.heroTitle': '我做了额外的好事，想申请红包鼓励',
    'habits.reward.heroBody': '比如主动整理房间、照顾弟弟妹妹、坚持练琴、帮家人完成临时任务。',
    'habits.reward.titlePlaceholder': '我做了什么？例如：主动收拾书桌',
    'habits.reward.titleAria': '我做了什么',
    'habits.reward.requestLabel': '想申请',
    'habits.reward.amountAria': '申请金额',
    'habits.reward.submit': '申请红包',
    'habits.reward.descPlaceholder': '可以补充说明：什么时候做的、做得怎么样（选填）',
    'habits.reward.descAria': '补充说明',
    'habits.reward.listAria': '红包申请记录',
    'habits.reward.myList': '我的红包申请',
    'habits.reward.pendingCount': '{n} 个等待审批',
    'habits.reward.requestedAmount': '申请 {amount}',
    'habits.reward.approvedAmount': '批准 {amount}',
    'habits.reward.statusPending': '等审批',
    'habits.reward.statusApproved': '已到账',
    'habits.reward.statusRejected': '未通过',
    'habits.reward.errTitle': '先写清楚你做了什么，再申请红包鼓励',
    'habits.reward.errAmount': '红包金额要大于 💰0.00',
    'habits.reward.toastSubmitted': '已发送给爸爸妈妈审批啦 🎁',

    'habits.claim.toastAuto': '好棒！+{amount} ✨',
    'habits.claim.toastPending': '已提交，等爸爸妈妈批准 👀',
    'habits.vault.title': '家长金库金币不够',
    'habits.vault.body': '你已经完成了「{title}」，但是爸爸妈妈的金库暂时不够发这笔奖励。可以一键提醒爸爸妈妈去后台领取今天的免费金币。',
    'habits.vault.reward': '这次奖励',
    'habits.vault.parentHave': '金库现在',
    'habits.vault.need': '需要',
    'habits.vault.remind': '提醒爸爸妈妈领金币',
    'habits.vault.later': '我知道了',
    'habits.vault.toastSent': '已经提醒爸爸妈妈啦',

    'habits.chore.todayTitle': '今日小任务（{n}）',
    'habits.chore.empty': '爸爸妈妈还没有布置小任务',
    'habits.chore.required': '必做',
    'habits.chore.missed': '已超时',
    'habits.chore.done': '已完成',
    'habits.chore.claim': '完成！',
    'habits.chore.deadline': '{time} 前',
    'habits.chore.autoApprove': '立即到账',
    'habits.chore.wishlistAria': '这个小任务关联的愿望',
    'habits.chore.wishlistPrefix': '推进愿望',
    'habits.chore.wishlistMore': '还有 {n} 个愿望',

    'habits.error.generic': '出错了',
  } as Record<string, string>,
  en: {
    'habits.title': 'Good habits',
    'habits.subtitle': 'Finish small tasks — earn coins and grow good habits',
    'habits.earnTitle': 'Ways to earn coins',
    'habits.earnHint': 'Finish small tasks, answer questions, help your family — all earn coins',

    'habits.wishlist.kicker': 'My wishes',
    'habits.wishlist.title': 'Wishlist',
    'habits.wishlist.count': '{n} active',
    'habits.wishlist.empty': 'No wishlist has been set yet',
    'habits.wishlist.status.active': 'in progress',
    'habits.wishlist.status.ready': 'ready',
    'habits.wishlist.status.fulfilled': 'fulfilled',
    'habits.wishlist.status.cancelled': 'cancelled',

    'habits.reward.kicker': 'Ask for a reward',
    'habits.reward.heroTitle': 'I did something extra — can I get a bonus?',
    'habits.reward.heroBody': 'Like tidying your room on your own, helping a younger sibling, sticking with piano practice, or helping out with a one-off task.',
    'habits.reward.titlePlaceholder': 'What did you do? e.g. tidied my desk',
    'habits.reward.titleAria': 'What I did',
    'habits.reward.requestLabel': 'Asking for',
    'habits.reward.amountAria': 'Amount',
    'habits.reward.submit': 'Ask for bonus',
    'habits.reward.descPlaceholder': 'A bit more (optional): when you did it, how it went',
    'habits.reward.descAria': 'More details',
    'habits.reward.listAria': 'Bonus requests',
    'habits.reward.myList': 'My bonus requests',
    'habits.reward.pendingCount': '{n} waiting for approval',
    'habits.reward.requestedAmount': 'asked {amount}',
    'habits.reward.approvedAmount': 'approved {amount}',
    'habits.reward.statusPending': 'waiting',
    'habits.reward.statusApproved': 'paid',
    'habits.reward.statusRejected': 'not this time',
    'habits.reward.errTitle': "Tell us what you did first, then ask for a bonus",
    'habits.reward.errAmount': 'Amount needs to be more than 0.00',
    'habits.reward.toastSubmitted': 'Sent to mum and dad for approval',

    'habits.claim.toastAuto': 'Nice! +{amount}',
    'habits.claim.toastPending': "Sent — waiting for mum or dad to approve",
    'habits.vault.title': 'Parent vault needs coins',
    'habits.vault.body': 'You finished "{title}", but the parent vault does not have enough coins to pay this reward yet. You can remind your parents to claim today’s free coins in the parent app.',
    'habits.vault.reward': 'Reward',
    'habits.vault.parentHave': 'Vault now',
    'habits.vault.need': 'Needed',
    'habits.vault.remind': 'Remind parents',
    'habits.vault.later': 'Got it',
    'habits.vault.toastSent': 'Parents have been reminded',

    'habits.chore.todayTitle': "Today's small tasks ({n})",
    'habits.chore.empty': "No small tasks set yet",
    'habits.chore.required': 'must do',
    'habits.chore.missed': 'overdue',
    'habits.chore.done': 'done',
    'habits.chore.claim': 'Done!',
    'habits.chore.deadline': 'before {time}',
    'habits.chore.autoApprove': 'paid right away',
    'habits.chore.wishlistAria': 'Wishes linked to this small task',
    'habits.chore.wishlistPrefix': 'Wish progress',
    'habits.chore.wishlistMore': '{n} more wishes',

    'habits.error.generic': 'Something went wrong',
  } as Record<string, string>,
};

export default habits;
